import { useState, useMemo, useEffect } from 'react';
import { GuestUserContext } from './guestUser.context.js';

const GUEST_EMAIL_STORAGE_KEY = 'indikin_guest_email';

export const GuestUserProvider = ({ children }) => {
  // Initialize state by reading from localStorage first.
  const [guestEmail, setGuestEmail] = useState(() => {
    try {
      const storedEmail = window.localStorage.getItem(GUEST_EMAIL_STORAGE_KEY);
      return storedEmail || '';
    } catch (error) {
      console.error('Failed to read from localStorage:', error);
      return '';
    }
  });

  // Effect to persist the guestEmail to localStorage whenever it changes.
  useEffect(() => {
    try {
      if (guestEmail) {
        window.localStorage.setItem(GUEST_EMAIL_STORAGE_KEY, guestEmail);
      } else {
        // If the email is cleared (e.g., after signup), remove it from storage.
        window.localStorage.removeItem(GUEST_EMAIL_STORAGE_KEY);
      }
    } catch (error) {
      console.error('Failed to write to localStorage:', error);
    }
  }, [guestEmail]);

  // Memoize the context value to prevent unnecessary re-renders of consumers.
  const value = useMemo(() => ({
    guestEmail,
    setGuestEmail,
  }), [guestEmail]);

  return (
    <GuestUserContext.Provider value={value}>
      {children}
    </GuestUserContext.Provider>
  );
};